import React, { Suspense, lazy, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { MimshakData } from "../../interfaces/DTO/mimshakData";
import { Contact } from "../../interfaces/DTO/crm/contact";

import DepositsChartWithToggle from "../PersonFinancialData/Charts/DepositsChartWithToggle";
import DepositSummaryByProductTable from "../PersonFinancialData/Tabels/DepositSummaryByProductTable";
import InsuranceDataTableForContacts from "./InsuranceDataTableForContacts";
import ContactInsuranceFilesCards from "./ContactInsuranceFilesCards";
import { Product } from "../../interfaces/DTO/mislaka_xml_models";
import { BeneficiariesMetricsWithDrawer } from "./BeneficiariesMetricsWithDrawer";

const HorizontalCoverageTable = React.lazy(() => import("../PersonFinancialData/Insurance/Tables/HorizontalCoverageTable"));
const InsuranceClientQuestionnaire = React.lazy(() => import("../PersonFinancialData/Insurance/ClientQuestionnaire"));
const InsuranceFeesLab = lazy(() => import("../FeesLab/InsuranceFeesLab"));

interface ContactsInsurancePageProps {
  mimshakData: MimshakData[];
  insuranceMimshakData: MimshakData[];
  viewedType: "USER" | "FAMILY";
  contacts: Contact[];
  insuranceProducts: Product[];
  selectedPeriod: string;
  id?: number;
  selectedPeriodType?: "REGULAR" | "PRE_ADVICE";
}

export const ContactsInsurancePage: React.FC<ContactsInsurancePageProps> = ({
  mimshakData,
  insuranceMimshakData,
  viewedType,
  contacts,
  insuranceProducts,
  selectedPeriod,
  id,
  selectedPeriodType = "REGULAR",
}) => {
  const familyId = viewedType === "FAMILY" && id ? id : undefined;
  const contactId = viewedType === "USER" && id ? id : (contacts[0]?.id ?? 0);
  const [showFeesLab, setShowFeesLab] = useState(false);

  return (
    <Suspense fallback={<CircularProgress />}>
      {/* מטריקות מוטבים עם כפתור ומגירה */}
      <BeneficiariesMetricsWithDrawer
        mimshakData={mimshakData}
        viewedType={viewedType}
      />

      {/* שאלון לקוח לכל איש קשר בנפרד */}
      {contacts.length > 1 ? (
        <Box sx={{ display: "flex", gap: 2 }}>
          {contacts.map((c) => (
            <Box key={c.id} sx={{ flex: 1 }}>
              <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1, mt: 1 }}>
                {[c.first_name, c.last_name].filter(Boolean).join(" ")}
              </Typography>
              <InsuranceClientQuestionnaire contactId={c.id} reportedPeriod={selectedPeriod} />
            </Box>
          ))}
        </Box>
      ) : contacts.length === 1 ? (
        <InsuranceClientQuestionnaire contactId={contacts[0].id} reportedPeriod={selectedPeriod} />
      ) : null}

      <Box>
        <HorizontalCoverageTable mimshakData={insuranceMimshakData} viewedType={viewedType} contacts={contacts} />
      </Box>

      {/* <CompactInsuranceSummary contactId={contacts[0].id} maxItems={123} /> */}
      <Box sx={{ width: '100%', mb: 2, mt: 1 }}>
        <InsuranceDataTableForContacts
          contacts={contacts}
          insuranceMimshakData={insuranceMimshakData}
          reportedPeriod={selectedPeriod}
        />
      </Box>
      {/* <ContactInsuranceDisplay
        contact={contacts[0]}  // ← מקבל אובייקט Contact מלא
         onEdit={(data) => console.log('Edit', data)}
         onDelete={(id) => console.log('Delete', id)}
        showContactInfo={true}
      /> */}
      <Box sx={{ width: '100%', mb: 2 }}>
        <Typography variant="h6" fontWeight={600} sx={{ mb: 1.5 }}>
          קבצי כיסויים ביטוחים
        </Typography>
        {contacts.map((c) => (
          <ContactInsuranceFilesCards key={c.id} contact={c} />
        ))}
      </Box>
      <Box>
        <DepositsChartWithToggle products={insuranceProducts} />
      </Box>
      <DepositSummaryByProductTable products={insuranceProducts} />

      <Box sx={{ mt: 3, mb: 2 }}>
        {!showFeesLab ? (
          <Button variant="outlined" onClick={() => setShowFeesLab(true)}>
            לבצע שינויים
          </Button>
        ) : (
          <Suspense fallback={<CircularProgress />}>
            <InsuranceFeesLab
              data={insuranceMimshakData}
              contacts={contacts}
              selectedPeriodType={selectedPeriodType}
              id={contactId}
              familyId={familyId}
              selectedPeriod={selectedPeriod}
            />
          </Suspense>
        )}
      </Box>
    </Suspense>
  );
};
